module.exports = __webpack_public_path__ + "img/5-Integras-Populated-Details-Page.61a9eedf.png";